/**
 * Home Hero & Core Divisons Slider
 */

// change slide fn
const updateSlide = (id) => {
  const hero = document.querySelector('.js-heroslider');
  hero.querySelectorAll('.nLoading').forEach((item) => {
    item.classList.remove('nLoading');
  });

  if (id) {
    hero.querySelectorAll('.nActive').forEach((item) => {
      item.classList.remove('nActive');
    });

    if (hero.querySelector(`:scope [data-slide='${id}']`)) {
      hero.querySelectorAll(`:scope [data-slide='${id}']`).forEach((item) => {
        item.classList.add('nActive');
      });
    } else {
      hero.querySelectorAll(':scope [data-slide="0"]').forEach((item) => {
        item.classList.add('nActive');
      });
    }
  }
};

(() => {
  if (!document.querySelector('.js-heroslider')) return;

  // check for URL param initslide=[x]
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const slideparam = urlParams.get('startslide') || '0';
  const startSlide = document.querySelector('.js-heroslider').getAttribute('start-slide') || slideparam;

  updateSlide(startSlide);

  // autoplay init
  let autoPlayToggle = false;
  if (document.querySelector('.js-heroslider[slider-autoplay="true"] .hero-slide-img img[data-slide="0"]')?.classList.contains('nActive')) {
    autoPlayToggle = true;
  }

  // autoplay fn
  const autoPlay = (APToggle, init = false) => {
    if (!APToggle) return;

    let nextSlide = 0;
    let slideCount = document.querySelector('.hero-nav').childElementCount;
    slideCount -= 1; // do not count the initial slide

    if (init) {
      nextSlide = Math.floor(Math.random() * slideCount) + 1;
    } else {
      const currentSlide = document.querySelector('.hero-nav .nActive')?.getAttribute('data-slide') || 0;
      nextSlide = (parseInt(currentSlide, 10) + 1);
      if (nextSlide === slideCount + 1) {
        nextSlide = 1;
      }
    }

    updateSlide(nextSlide);

    setTimeout(() => {
      autoPlay(autoPlayToggle);
    }, 8000);
  };

  setTimeout(() => {
    autoPlay(autoPlayToggle, true);
  }, 8000);

  // click interaction
  const slideInteraction = (e) => {
    const target = e.currentTarget;
    if (target.classList.contains('nActive')) return;

    if (autoPlayToggle) {
      autoPlayToggle = false;
    }

    const id = target.getAttribute('data-slide');
    updateSlide(id);
  };

  document.querySelectorAll('.js-toggle-hero').forEach((item) => {
    if (document.body.classList.contains('ex-home')) {
      item.addEventListener('mouseover', (e) => {
        slideInteraction(e);
      });
    } else {
      item.addEventListener('click', (e) => {
        slideInteraction(e);
      });
      item.addEventListener('keyup', (e) => {
        if (!(e.key === 'Enter')) return;
        slideInteraction(e);
      });
    }
  });
})();

/**
 * Scroll down
 */
(() => {
  const scroll = (e) => {
    window.scrollTo({
      top: e.currentTarget.offsetTop,
      behavior: 'smooth',
    });
  };

  document.querySelectorAll('.js-scroll').forEach((item) => {
    item.addEventListener('click', (e) => {
      scroll(e);
    });
    item.addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      scroll(e);
    });
  });
})();
